import { types } from 'actions/directory'

const directoryReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case types.INIT:
      return payload

    default:
      return state
  }
}

export default directoryReducer;
